import{jsxs as e,jsx as r}from"react/jsx-runtime";import{Body as o}from"@vds-core/typography";import{hexToRgba as t,calculateRem as n,generateUUID as i}from"@vds-core/utilities";import{AccessibilityTokens as a}from"@vds-tokens/accessibility";import{ColorTokens as p}from"@vds-tokens/color";import{LayoutTokens as s}from"@vds-tokens/layout";import{useState as c,useRef as d,useEffect as l}from"react";import u from"styled-components";import{formatTime as g}from"./utlils/formatTime.js";const m=p.palette.gray44.value,b=p.background.primary.inverse.dark.value,h=p.elements.primary.ondark.value,x=p.palette.gray65.value,f=u.div.withConfig({displayName:"ProgressBarWrapper",componentId:"VDS__sc-1h97ixe-0"})`
  display:flex;
  flex-direction: column;
  height: 4px;
  position: relative;
  width: 100%;
  &:hover {
    height: 8px;
    input, progress{
     height: 8px;
    }

    progress::-webkit-progress-bar {
        background-image: linear-gradient(
            ${x},
            ${x}
          ),
          linear-gradient(${m}, ${m});
        background-repeat: no-repeat;
        background-size: ${function({seekPercentage:e}){return`${e}%`}} 100%,
          100% 100%;
        height: 8px;
      }
    
    div {
      ${function({time:e}){return e&&"\n        display: flex;\n      "}}
    }
      input {
        &::-webkit-slider-thumb {
          box-shadow: 0px 1px 11px 0px ${t(p.palette.black.value,.12)},
          0px 3px 5px 0px ${t(p.palette.black.value,.05)};
          display: block;
        }
      }
    }
  }
`,k=u.progress.withConfig({displayName:"Progress",componentId:"VDS__sc-1h97ixe-1"})`
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  border-radius: 4px;
  height: 4px;
  pointer-events: none;
  overflow: hidden;
  width: 100%;
  position: absolute;
  top: 0;
  &::-webkit-progress-bar {
    background: ${m};
    border-radius: 4px;
  }
  &::-webkit-progress-value {
    background: ${b};
    border-radius: ${function({value:e,max:r}){return e===r?"4px":"4px 0px 0px 4px"}};
  }
  &::-moz-progress-bar {
    background: ${m};
    border-radius: 4px;
  }
`,v=u.input.withConfig({displayName:"Seek",componentId:"VDS__sc-1h97ixe-2"})`
  -moz-appearance: none;
  -webkit-appearance: none;
  background: transparent;
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;
  height: 4px;
  margin: 0;
  position: absolute;
  top: 0;
  &::after {
    top: -20px;
    bottom: -20px;
    position: absolute;
    width: 100%;
    content: '';
    background-color: transparent;
  }
  width: 100%;
  &:focus-visible {
    outline: ${n(a.focusring.borderwidth.value)}
      ${a.focusring.borderstyle.value}
      ${a.color.focusring.ondark.value};
    outline-offset: ${s.space["2X"].value};
  }
  &:focus {
    &::-webkit-slider-thumb {
      display: block;
    }
  }
  &::-webkit-slider-runnable-track {
    -webkit-appearance: none;
    transition: all 0.4s ease;
    width: 100%;
  }
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    background: ${h};
    border-radius: 16px;
    cursor: pointer;
    display: none;
    height: 16px;
    width: 16px;
  }
  &::-moz-range-track {
    background: transparent;
    border: 1px solid transparent;
    border-radius: 1.3px;
    cursor: pointer;
    height: 8.4px;
    width: 100%;
  }
  &::-moz-range-thumb {
    background: ${h};
    border-radius: 4px;
    cursor: pointer;
    height: 2px;
    margin-top: 5px;
    width: 0px;
  }
`,w=u.div.withConfig({displayName:"SeekTooltip",componentId:"VDS__sc-1h97ixe-3"})`
  align-items: center;
  background-color: ${p.background.secondary.dark.value};
  border-radius: ${s.shape.cornerradius.circle.value};
  box-sizing: border-box;
  display: none;
  flex-direction: row;
  font-weight: bold;
  left: ${function({left:e}){return e}};
  height: ${function({isCompact:e}){return e?"24px":"40px"}};
  padding: ${function({isCompact:e}){return e?`0px ${s.space["2X"].value}`:`0px ${s.space["4X"].value}`}};
  position: absolute;
  top: ${function({isCompact:e}){return e?"-40px":"-64px"}};
`,$=u.label.withConfig({displayName:"SeekLabel",componentId:"VDS__sc-1h97ixe-4"})`
  display: inline-block;
  width: 100%;
`,y=function({duration:t,progress:n,onSeek:a,layout:s}){const[u,m]=c(0),[b,h]=c("0px"),[x,y]=c(0),[C]=c(i()),S=d(null),_=d(null),z="compact"===s;l((function(){if(S.current){const e=S.current.getBoundingClientRect().width,r=0===n?0:(n/t*(e-8)+8)/e*100;y(Math.floor(r))}}),[n]);const D="0"!==g(u).hours?`${g(u).hours}:${g(u).minutes}:${g(u).seconds}`:`${g(u).minutes}:${g(u).seconds}`;return e(f,{seekPercentage:u/t*100,"aria-live":"off",time:u,children:[r(k,{value:x,min:0,max:100,"aria-hidden":"true"}),r($,{htmlFor:C.toString(),children:r(v,{onKeyDown:function(e){const r=Math.round(u)||0;if("ArrowRight"===e.key||"ArrowLeft"===e.key)if(e.preventDefault(),"ArrowRight"===e.key){const e=r+5<t?r+5:t;m(e),a(e)}else{const e=r-5>0?r-5:0;m(e),a(e)}},ref:S,onMouseMove:function(e){const r=S.current;if(r){const o=_.current?_.current.getBoundingClientRect().width/2:0,n=r.getBoundingClientRect(),i=(e.clientX-n.left)/n.width*t;m(i<0?0:i),h(e.clientX-n.left-o+"px")}},value:n,min:0,type:"range",step:"any",max:t,onChange:function(e){const r=u||e.target.value;a(r)},"aria-live":"off","aria-label":"Video progress",id:C,progressPercentage:x})}),r(w,{left:b,"aria-hidden":"true",isCompact:z,ref:_,children:r(o,{size:z?"small":"large",color:p.elements.primary.ondark.value,"data-testid":"seek-pop-over-time",children:D})})]})};export{y as default};
